import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useAuthRoles } from "../useAuthRoles";
import { buildServiceUrl } from "../../utils/urlBuilder";

export function usePutInternalUser() {
  const { token } = useAuthRoles();

  return useMutation({
    mutationKey: ["internalUser", "update"],
    mutationFn: async ({ userId, payload }) => {
      if (!userId) {
        throw new Error("Missing userId");
      }

      return axios.put(
        buildServiceUrl("connectorMaster", `keycloak/internal/users/${userId}`),
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
    },
  });
}
